/**
 * Auto-generated product descriptions for the Security sections.
 *
 * Shape: a one-line title, then AT MOST two short bullets (Jaron, Aug 7/12 and
 * Sep 24 2026, Monday 12790297504: "I have asked to lower the amount of
 * lines"). Keep it that way when adding a product - securityAutoNotes.test.ts
 * fails on a third bullet. Bullets should also avoid the words the alarm-safe
 * filter drops on customer-facing surfaces (alarm, siren, sensor/detector,
 * solar, arm/disarm) so both survive on the Job Summary / NOTES page.
 *
 * Text is copied onto the customer row when a product is picked (see
 * `react-utils.tsx` changeVal) - editing it here only changes rows picked
 * from now on, never rows already saved (V55).
 */
export const securityAutoNotes: Readonly<Record<string, string>> = {
  // #region Alarm System
  'HomeBase 3':
    'Eufy HomeBase 3 —\n• Central hub for your eufy cameras and devices, local storage with no monthly fee\n• On-device AI person and face recognition',

  Keypad:
    'Security System Keypad —\n• PIN code access to control the system\n• Integrates with HomeBase 3',

  'Door Sensor':
    'Door Entry Sensor —\n• Detects door opening\n• Mobile push notifications',

  'Window Sensor':
    'Window Entry Sensor —\n• Detects window opening\n• Mobile push notifications',

  'Garage Sensor':
    'Garage Door Entry Sensor —\n• Detects garage door opening\n• Mobile push notifications',

  'Door Sensors':
    'Entry Detection Sensors —\n• Detects door or window opening\n• Mobile push notifications',

  'Window Sensors':
    'Entry Detection Sensors —\n• Detects window opening\n• Mobile push notifications',

  'Motion Sensor':
    'Motion Sensor —\n• Detects interior movement\n• Mobile alert integration',

  'Motion Detector':
    'Motion Sensor —\n• Detects interior movement\n• Mobile alert integration',

  'Smoke Detector':
    'Smoke Detection Device —\n• Smoke detection with audible warning\n• Sends mobile notifications',

  'Carbon Monoxide (CO) Detector':
    'Carbon Monoxide Detector —\n• Detects presence of CO gas\n• Audible warning and mobile notifications',

  'Glass Break Detector':
    'Glass Break Sensor —\n• Detects the sound of breaking glass\n• Instant mobile notification',

  'Medical Alert Pendant':
    'Medical Alert Pendant —\n• Wearable emergency button\n• Designed for emergency assistance situations',

  'Medical Pendant':
    'Medical Alert Pendant —\n• Wearable emergency button\n• Designed for emergency assistance situations',

  'eufy Key Fob E10':
    'eufy Security Key Fob E10 —\n• One-press control of the system\n• Integrates with HomeBase 3',

  Homebase:
    'Eufy HomeBase —\n• Central control hub with app-based remote control\n• Real-time push notifications',

  Smoke:
    'Smoke Detection Device —\n• Smoke detection with audible warning\n• Sends mobile notifications',
  // #endregion Alarm System

  // #region CCTV
  'NVR (Network Video Recorder)':
    'Network Video Recorder —\n• Supports up to 8 PoE cameras with 24/7 recording\n• Centralized camera management, no mandatory subscription',

  '2 TB Video Storage System':
    '2TB Hard Drive —\n• Standard local video storage\n• Playback & search functionality',

  '4 TB Video Storage System': '4TB Hard Drive —\n• Extended storage capacity',

  '8 TB Video Storage System':
    '8TB Hard Drive —\n• Long-term footage retention',

  '16 TB Video Storage System':
    '16TB Hard Drive —\n• Maximum recording retention capacity',

  'S4 Max Camera (PoE)':
    'Professional AI Dual-Lens Surveillance Camera —\n• 4K dual-lens with pan / tilt / zoom\n• Human, vehicle and animal detection, two-way audio',

  'Bullet Cam E40 (PoE)':
    'Hardwired Turret Security Camera —\n• HD resolution with night vision\n• Hardwired PoE connection, recorded through NVR',

  'Turret E41 (PoE)':
    'Turret Security Camera —\n• HD resolution, fixed wide-angle lens\n• Motion-triggered recording and two-way audio',

  'Indoor Camera':
    'Indoor Smart Security Camera —\n• HD resolution with motion detection alerts\n• Two-way audio and live mobile streaming',

  'Doorbell E340':
    'Video Doorbell E340 —\n• HD video with night vision\n• Motion detection alerts and two-way audio',

  'Doorbell E340 (Battery)':
    'Battery-Powered Video Doorbell —\n• HD video with motion detection alerts\n• Two-way audio, rechargeable battery',

  'Doorbell E340 (Wired)':
    'Hardwired Video Doorbell —\n• HD video with motion detection alerts\n• Two-way audio, continuous power connection',
  // #endregion CCTV

  // #region WiFi Cameras
  'Solar S4 Camera':
    'Solar S4 Wireless Cam —\n• 4K dual-lens with human, vehicle and animal detection\n• Two-way audio, no Ethernet wiring required',

  'Solar S4 Wireless Cam':
    'Solar S4 Wireless Cam —\n• 4K dual-lens with human, vehicle and animal detection\n• Two-way audio, no Ethernet wiring required',

  'eufyCam S3 Pro':
    'eufyCam S3 Pro —\n• 4K resolution with color night vision\n• AI facial recognition, wire-free installation',

  'SoloCam E30':
    'SoloCam E30 —\n• 2K wire-free outdoor camera with built-in spotlight\n• Motion detection alerts and two-way audio',

  'Indoor Camera E220':
    'Indoor Camera E220 —\n• 2K resolution with pan & tilt and night vision\n• Motion tracking and two-way audio',

  'Indoor Camera S350':
    'Indoor Camera S350 —\n• 4K dual-lens with 360° pan & tilt\n• Color night vision, AI motion detection',

  'Smart Display (Eufy)':
    'Eufy Smart Display —\n• Live multi-camera viewing on a touchscreen\n• Local playback without needing a phone',

  'Solar S340 Camera':
    'SoloCam S340 Solar Camera —\n• 3K dual-lens with 8x hybrid zoom and automatic motion tracking\n• Two-way audio, 8 GB built-in storage, no monthly fee',

  // No spotlight on this model (unlike the S230/S340) — do not add one here.
  'SoloCam S220':
    'SoloCam S220 Solar Camera —\n• 2K wire-free outdoor camera with night vision\n• Two-way audio, 8 GB built-in storage, no monthly fee',
  // #endregion WiFi Cameras

  // #region Home Automation
  'Smart Panel':
    'Smart Home Control Panel —\n• Wall touchscreen to control locks, cameras and lights in one place\n• Real-time alerts and remote access from the app',

  'Smart Lock C220':
    'Smart Door Lock C220 —\n• Keypad + app access with auto-lock\n• Access log history',

  'FamiLock Doorbell + Lock':
    'FamiLock Video Doorbell + Smart Lock —\n• Built-in video doorbell with keypad smart lock\n• Two-way audio and remote access via app',

  // Jaron, dev-dpt Oct 8 (13241271719): "Nest Thermostat $180, MyQ Garage
  // Door Opener $150 - To Home Automation section".
  'Nest Thermostat':
    'Nest Smart Thermostat —\n• Learns your schedule and adjusts the temperature by itself\n• Control heating and cooling from the app',

  'MyQ Garage Door Opener':
    'myQ Smart Garage Door Opener —\n• Open, close and check the garage door from the app\n• Alerts when the door is left open',
  // #endregion Home Automation
}
